import {
  CREATE_ORDER,
  UPDATE_USER_BILLING_INFO,
} from './constants'

export function createOrder (payload) {
  return {
    type: CREATE_ORDER,
    payload,
  }
}

export function updateUserBillingInfo (payload) {
  return {
    type: UPDATE_USER_BILLING_INFO,
    payload,
  }
}
